module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subject"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Kodifikasi',
          to: {
            path: '/'
          }
        },
        {
          text: 'Pengaturan Bab'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Pengaturan Bab")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Daftar Mata Pelajaran ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', [_c('v-text-field', {
    staticClass: "search_box",
    attrs: {
      "outlined": "",
      "height": "36px",
      "hide-details": "",
      "small": "",
      "dense": "",
      "placeholder": "Ketik kata kunci dan tekan enter"
    },
    model: {
      value: (_vm.query),
      callback: function($$v) {
        _vm.query = $$v
      },
      expression: "query"
    }
  }, [_c('template', {
    slot: "prepend-inner"
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "10px !important"
    },
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8.33342 15.0001C9.81256 14.9998 11.2491 14.5046 12.4142 13.5934L16.0776 17.2567L17.2559 16.0784L13.5926 12.4151C14.5042 11.2498 14.9997 9.81295 15.0001 8.33341C15.0001 4.65758 12.0092 1.66675 8.33342 1.66675C4.65758 1.66675 1.66675 4.65758 1.66675 8.33341C1.66675 12.0092 4.65758 15.0001 8.33342 15.0001ZM8.33342 3.33341C11.0909 3.33341 13.3334 5.57591 13.3334 8.33341C13.3334 11.0909 11.0909 13.3334 8.33342 13.3334C5.57591 13.3334 3.33341 11.0909 3.33341 8.33341C3.33341 5.57591 5.57591 3.33341 8.33342 3.33341Z",
      "fill": "#073554"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9.50994 7.15507C9.82577 7.47174 9.99994 7.89007 9.99994 8.33341H11.6666C11.6673 7.89543 11.5813 7.46165 11.4133 7.05714C11.2454 6.65264 10.999 6.28543 10.6883 5.97674C9.4266 4.71674 7.2391 4.71674 5.97827 5.97674L7.15494 7.15674C7.78827 6.52507 8.87994 6.52674 9.50994 7.15507Z",
      "fill": "#073554"
    }
  })])])], 2)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticStyle: {
      "min-height": "none !important"
    },
    attrs: {
      "three-line": ""
    }
  }, [_vm._l((_vm.filteredCards), function(subject) {
    return _c('v-list-item', {
      key: subject.id,
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/topic-management/detail',
            query: {
              subject_id: subject.id
            },
          })
        }
      }
    }, [_c('v-list-item-avatar', [_c('v-img', {
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'background-size:20px' :
        ''),
      attrs: {
        "src": subject.picture ?
          subject.picture :
          '@/assets/blank.svg'
      }
    })], 1), _vm._v(" "), _c('v-list-item-content', {
      staticClass: "pt-4 pb-6"
    }, [_c('v-list-item-title', [_c('span', {
      staticClass: "roboto-text darkblue--text",
      class: _vm.$vuetify.breakpoint.smAndDown ?
        'font-weight-600' :
        'font-weight-700',
      style: (_vm.$vuetify.breakpoint.smAndDown ?
        'font-size:15px' :
        '')
    }, [_vm._v("\n                                " + _vm._s(subject.name) + "\n                            ")])]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v("\n                            Kode: " + _vm._s(subject.code) + "\n                        ")])], 1), _vm._v(" "), _c('v-list-item-action', {
      staticClass: "d-flex align-self-center"
    }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27eb842e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/kodifikasi/components/TopicManagement.vue
// module id = 1559
// module chunks = 1